import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import * as enums from "../../enumerations";
import * as modelsGet from "../../models/get";
import * as modelsCalendar from "../../models/calendar";
import * as utils from "../../utils/utils";
import { CalendarMonthDay } from "./calendarMonthDay";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Die momentane Route.
     */
    route: () => uri.URI,

    /**
     * Der angemeldete Benutzer.
     */
    currentUser: modelsGet.IUser,

    /**
     * Alle benötigten Einstellungen.
     */
    settings: {
        eventDayViewTemplate: string
    },

    /**
     * Der selektierte Kalender oder die Kalendergruppe.
     */
    selectedObject: modelsCalendar.ISelectedObject,

    /**
     * Selektierte Datum.
     */
    selectedDate: moment.Moment,

    /**
     * Der selektierte Kalender (nur wenn eine Kalendergruppe ausgewählt ist).
     */
    selectedCalendar: modelsGet.ICalendar,

    /**
     * Die Wochen samt Tage zum rendern der Monatsansicht.
     */
    weeks: modelsCalendar.IWeek[],

    /**
     * Enthält alle Termine und Sperren für die Monatsansicht.
     */
    appointments: modelsGet.IAppointment[],

    /**
     * Wird ausgeführt sobald sich das Popup für die Termindetails öffnet.
     * @param e Das auslösende Ereignis.
     * @param appointment Der gebundene Termin oder die Sperre.
     */
    onAppointmentPopupOpening?: (e: MouseEvent, appointment: modelsGet.IAppointment) => boolean
}

export class CalendarMonth extends React.Component<IProperties>
{
    /**
     * Initialisiert die Komponente @see CalendarMonth.
     * @param props Die Eigenschaften dieser Komponente.
     */
    constructor(props: IProperties)
    {
        super(props);
    }

    /**
     * Zu einem beliebigen Tag springen.
     */
    private onDayClick = (newDate: moment.Moment): void =>
    {
    }

    /**
     * Rendert den Header mit den Wochentagen.
     */
    private renderHeader(): JSX.Element[]
    {
        var header: JSX.Element[] = []
        var weekdays: string[] = moment.weekdays(true);

        for (var i = 0; i < weekdays.length; i++)
        {
            let column: number = i + 1;
            header.push(
                <div
                    className="calendar_header"
                    style={utils.getGridChildStyle(column, column, 1, 1)}>
                    {weekdays[i]}
                </div>
            );
        }

        return header;
    }

    /**
     * Rendert die anzuzeigenen Tage.
     * @param date Das Datum anhand dessen die Tage ermittelt werden sollen.
     * @returns Eine Komponente mit den Tagen die im Datepicker angzeigt werden sollen.
     */
    private renderDays(date: moment.Moment, weeks: modelsCalendar.IWeek[]): JSX.Element[]
    {
        const {
            route,
            currentUser,
            settings,
            selectedObject,
            selectedCalendar,
            appointments,
            onAppointmentPopupOpening
        } = this.props;
        const days: JSX.Element[] = [];
        var calendar: modelsGet.ICalendar = (selectedObject.type === enums.CalendarObjectType.calendar ? selectedObject.data as modelsGet.ICalendar : selectedCalendar);
        var eventDayViewTemplate: string = settings.eventDayViewTemplate;

        for (let week of weeks)
        {
            for (let day of week.daysOfWeek)
            {
                let {
                    date,
                    isToday,
                    isOutsideCurrentMonth,
                    isFirstDayOfMonth,
                    gridColumn,
                    gridRow
                } = day;

                days.push(
                    <CalendarMonthDay
                        style={utils.getGridChildStyle(gridColumn, gridColumn, gridRow, gridRow)}
                        route={route}
                        currentUser={currentUser}
                        selectedObject={selectedObject}
                        currentSelectedCalendar={calendar}
                        settings={settings}
                        headerText={isFirstDayOfMonth ? date.date().toString() + ". " + moment.monthsShort(date.month()) : date.date().toString() + "."}
                        date={moment(date)}
                        appointments={day.appointments ? day.appointments : []}
                        isOutsideCurrentMonth={isOutsideCurrentMonth}
                        isToday={isToday}
                        isSelected={false}
                        onClick={this.onDayClick}
                        onAppointmentPopupOpening={onAppointmentPopupOpening} />
                );
            }
        }

        return days;
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        const {
            currentUser,
            settings,
            selectedObject,
            selectedDate,
            selectedCalendar,
            weeks
        } = this.props;

        if (weeks != null)
        {
            return (
                <div
                    className="calendar-month"
                    style={(weeks.length === 5 ? utils.getGridRowsStyle("auto 1fr 1fr 1fr 1fr 1fr") : utils.getGridRowsStyle("auto 1fr 1fr 1fr 1fr 1fr 1fr"))}>
                    {this.renderHeader()}
                    {this.renderDays(selectedDate, weeks)}
                </div>
            );
        }
        else
        {
            return null;
        }
    }
}